// This filter transform will remove large or non-serializable data from the locally persisted state.
// The publisher object has looping data structures which break serialization.
// The files object contains base64 data URIs that can exceed sessionStorage quota.
// TODO: Real fix would be not to include the publisher in redux at all.
import _ from 'lodash'

export default function filterOpenTokPublisher(inboundState) {
  const filteredState = _.cloneDeep(inboundState)
  _.unset(filteredState, 'opentok.publisher')
  _.unset(filteredState, 'files')
  return filteredState
}
